import React, { Fragment } from "react";

const UsersInChat = () => {
  return (
    <Fragment>
      <div className="side-container border-right grey">
        <div className="online-title-container-alt">
          <div className="border-alt blue">
            <p className="online-title-alt blue">
              <i className="fas fa-users blue mr-5"></i>Users In Chat
            </p>
          </div>
        </div>
        <div className="all-users">
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
          <div className="single-user">
            <div className="outside-container">
              <div className="flex-only">
                <div className="online-avi-container">
                  <div className="avi-color-border green">
                    <div className="drop-down-result-avi"></div>
                  </div>
                </div>
                <div className="online-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font">User Name</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="user-buttons">
              <button className="user-button background-red">
                <i className="fas fa-ban mx-5"></i>Block
              </button>
              <button className="user-button background-red">
                <i className="fas fa-exclamation-circle mx-5"></i>Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UsersInChat;
